<template>
  <div class="sidebarWindow bigSidebarWindow">
    <div class="sidebarWindowTitle layers-title">
      <div class="layertitleTextContainer">
        <span class="layerTitle">{{ $tc("Layer", 2) }}</span>
        <!-- <span class="layerProfile">
          Default
          <v-icon
            slot="append"
            class="defaultChevron"
          >
            mdi-chevron-down
          </v-icon>
        </span> -->
      </div>
<!--         
      <span @click="closeLayers" class="closeSidebarArrow">
        <CloseWindowSVG />
      </span> -->
    </div>

    <div style="margin: 5px 12px 10px 10px">
      <v-layout
        row
        justify-start
        align-center
        @click="toggleShowTabNetworkLayers"
        style="margin-top: 25px"
      >
        <component :is="networkLayersIcon" class="searchSVG" />
        <span class="layers-filter">{{ $t("FilterByNetwork") }}</span>
      </v-layout>

      <v-text-field
        v-model="search"
        prepend-inner-icon="search"
        :label="$t('Search')"
        :placeholder="$t('Search')"
        single-line
        class="layer-search"
      />
    </div>

    <div class="layers-tree scroll-fire-fox">
      <v-treeview
        open-on-click
        :items="layersMap"
        :search="search"
        item-key="id"
        item-text="label"
        return-object
        id="layers-sidebar-tree"
        :open="openMapLayer"
        @update:open="updateExpandedMapLayer"
        expand-icon="mdi-chevron-down"
        on-icon="mdi-checkbox-marked"
        off-icon="mdi-checkbox-blank-outline"
      >
        <template v-slot:prepend="{ item, open }">
          <v-checkbox
            :input-value="
              JSON.stringify(selectedMapLayer) === JSON.stringify(item)
            "
            v-if="!(item.label === 'Maps')"
            color="#4fa2b7"
            @change="updateSelectedLayersMap(item)"
          />
        </template>
        <template v-slot:label="{ item }">
          <div class="layer-item-label">
            <span class="labelSpan">{{ item.label }} </span>
          </div>
        </template>
      </v-treeview>
      <v-treeview
        :value="tree"
        @input="updateSelectedLayers"
        :open="openLayers"
        @update:open="updateExpandedLayers"
        open-on-click
        :items="allLayers"
        :search="search"
        selectable
        item-key="id"
        item-text="label"
        return-object
        id="layers-sidebar-tree"
        expand-icon="mdi-chevron-down"
        on-icon="mdi-checkbox-marked"
        off-icon="mdi-checkbox-blank-outline"
        indeterminate-icon="mdi-minus-box"
      >
        
        <template v-slot:label="{ item }">
          <div class="layer-item-label">
            <span
              class="labelSpan"
              :title="
                item.translatable_label
                  ? $tc(item.translatable_label, 2)
                  : item.label
              "
              >{{
                item.translatable_label
                  ? $tc(item.translatable_label, 2)
                  : item.label
              }}</span
            >
          </div>
        </template>

        <template v-slot:append="{ item, selected }">
          <v-btn
            v-if="item.has_geoserver_label_button"
            @click="toggleGeoserverLabel(item)"
            icon
            text
            x-small
            class="ma-0"
            :disabled="!selected"
          >
            <v-icon
              v-if="item.has_geoserver_label_button"
              size="12"
              :color="
                isGeoserverLabelActive(item, selected)
                  ? 'accent'
                  : 'secondary darken-1'
              "
            >
              {{
                isGeoserverLabelActive(item, selected)
                  ? "mdi-tag"
                  : "mdi-tag-outline"
              }}
            </v-icon>
          </v-btn>

          <!-- <v-menu offset-y rounded="lg">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                text
                x-small
                class="ma-0"
                :disabled="item.has_geoserver_label_button ? false : true"
                @click.stop
               >
                <v-icon>
                  mdi-dots-vertical
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="!isGeoserverLabelActive(item, selected)">
                <v-list-item-title @click="toggleGeoserverLabel(item)">
                  <v-icon style="margin-right: 8px" color="#767676">
                    mdi-eye
                  </v-icon>
                  Show Label
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="isGeoserverLabelActive(item, selected)">
                <v-list-item-title @click="toggleGeoserverLabel(item)">
                  <v-icon style="margin-right: 8px" color="#767676">
                    mdi-eye-off
                  </v-icon>
                  Hide Label
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu> -->
        </template>
      </v-treeview>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { bus } from "@/main";
import CloseWindowSVG from "@/assets/sidebar/closeWindowArrow.svg";
import DesignLayersSVG from "@/assets/designer_layers_svgs/design_layers.svg";
import DesignLayersFillSVG from "@/assets/designer_layers_svgs/design_layers_fill.svg";


export default {
  name: "Layers",

  components: {
    CloseWindowSVG,
    DesignLayersSVG,
    DesignLayersFillSVG
  },

  data() {
    return {
      allLayers: [],

      tree: [],
      defaultSelectedLayersCount: 0,
      loadedActiveLayers: false,

      openLayers: [],
      defaultExpandedLayersCount: 0,
      loadedExpandedLayers: false,

      activeGeoserverLabels: [],
      defaultActiveGeoserverLabelsCount: 0,
      loadedActiveGeoserverLabels: false,

      search: "",

      /**
       * Defines the map layers
       */
      layersMap: [],
      /**
       * Defines which map layer is selected
       */
      selectedMapLayer: {},
      openMapLayer: [],
      loadedExpandedMapLayer: false
    };
  },

  computed: {
    showNetworkLayers() {
      return this.$store.getters.isShowTabNetworkLayers;
    },

    networkLayersIcon() {
      return this.showNetworkLayers ? DesignLayersFillSVG : DesignLayersSVG;
    }
  },

  mounted() {
    this.initializeLayers();
    bus.$on("activeLayer", () => { this.setSelectedLayers();});
  },

  destroyed() {
    bus.$off("activeLayer");
  },

  methods: {
    ...mapActions([
      "getLayersMenu",
      "setShowTabNetworkLayers",
      "setActiveNetworkFilters",
      "getConsumablesWMS",

    ]),

    initializeLayers() {
      this.getAllLayers().then(() => {
        this.setOpenLayers();
        this.setSelectedLayers();
        this.setActiveGeoserverLabels();
        this.setSelectedMapLayers();
        this.setOpenMapLayers();
      });


    },

    /**
     * Get client layers
     */
    async getAllLayers(){
      try{
        const allLayers = await this.getLayersMenu();
        const WMSArray = await this.getWMS();
        /**
         * Separated the layer referring to the Map from the other layers.
         * It was necessary to separate it into different tree-selects,
         * because on the map you can only select one item
         */
        let indexLayerMap = allLayers.findIndex(
          layer => layer.label === "Maps"
        );
        let layerMap = [allLayers[indexLayerMap]];
        //add array of WMS to maps list
        if (WMSArray) {
          WMSArray.forEach(element => {
            layerMap[0].children.push({
              label: !!element.description ? element.description : element.code,
              id: element.id,
              url: element.url
            })
          });
        }
        allLayers.splice(indexLayerMap, 1);
        this.allLayers = allLayers;
        this.layersMap = layerMap;
      }catch(err){
        console.log(err);
      }
    },
    async getWMS(){
      try{
        const WMS = await this.getConsumablesWMS();
        return WMS;
      }catch(err){
        console.log(err)
      }
    },
    setOpenLayers() {
      let expandedSidebarLayers = JSON.parse(
        sessionStorage.getItem("expanded_layer_levels")
      );
      if (expandedSidebarLayers) {
        this.openLayers = expandedSidebarLayers;
        this.loadedExpandedLayers = true;
      } else {
        for (const layer of this.allLayers) {
          this.setLayersOpenByDefault(layer, () => {
            this.loadedExpandedLayers = true;
            this.updateExpandedLayers(this.openLayers);
          });
        }
      }
    },

    setSelectedLayers() {
      let selectedLayers = JSON.parse(sessionStorage.getItem("active_layers"));
      if (selectedLayers) {
        this.tree = selectedLayers;
        this.loadedActiveLayers = true;
      } else {
        for (const layer of this.allLayers) {
          this.setLayerSelectedByDefault(layer, () => {
            this.loadedActiveLayers = true;
            this.updateSelectedLayers(this.tree);
          });
        }
      }
    },

    setActiveGeoserverLabels() {
      let activeGeoserverLabels = JSON.parse(
        sessionStorage.getItem("active_geoserver_labels")
      );
      if (activeGeoserverLabels) {
        this.activeGeoserverLabels = activeGeoserverLabels;
        this.loadedActiveGeoserverLabels = true;
      } else {
        for (const layer of this.allLayers) {
          this.setActiveGeoserverLabelsByDefault(layer, () => {
            this.loadedActiveGeoserverLabels = true;
            this.updateActiveGeoserverLabels();
          });
        }
      }
    },

    setLayersOpenByDefault(layerLevel, callback) {
      this.defaultExpandedLayersCount++;
      if (
        layerLevel.hasOwnProperty("expanded_default") &&
        layerLevel.expanded_default
      ) {
        this.openLayers.push(layerLevel);
      }
      if (
        layerLevel.hasOwnProperty("children") &&
        layerLevel.children.length > 0
      ) {
        for (const child of layerLevel.children) {
          this.setLayersOpenByDefault(child, callback);
        }
      }
      this.defaultExpandedLayersCount--;
      if (this.defaultExpandedLayersCount === 0 && callback) {
        callback();
      }
    },

    setLayerSelectedByDefault(layerLevel, callback) {
      this.defaultSelectedLayersCount++;
      if (
        layerLevel.hasOwnProperty("selected_default") &&
        layerLevel.selected_default
      ) {
        this.tree.push(layerLevel);
      }
      if (
        layerLevel.hasOwnProperty("children") &&
        layerLevel.children.length > 0
      ) {
        for (let child of layerLevel.children) {
          this.setLayerSelectedByDefault(child, callback);
        }
      }
      this.defaultSelectedLayersCount--;
      if (this.defaultSelectedLayersCount === 0 && callback) {
        callback();
      }
    },

    setActiveGeoserverLabelsByDefault(layerLevel, callback) {
      this.defaultActiveGeoserverLabelsCount++;
      if (
        layerLevel.has_geoserver_label_button &&
        layerLevel.geoserver_label_shown_default &&
        layerLevel.hasOwnProperty("selected_default") &&
        layerLevel.selected_default
      ) {
        let layer = this.getLayerLevelLayerName(layerLevel);
        this.activeGeoserverLabels.push(layer);
      }
      if (
        layerLevel.hasOwnProperty("children") &&
        layerLevel.children.length > 0
      ) {
        for (let child of layerLevel.children) {
          this.setActiveGeoserverLabelsByDefault(child, callback);
        }
      }
      this.defaultActiveGeoserverLabelsCount--;
      if (this.defaultActiveGeoserverLabelsCount === 0 && callback) {
        callback();
      }
    },

    updateSelectedLayers(layers) {
      if (this.loadedActiveLayers) {
        this.tree = layers;

        let activeLayers = [];
        for (const leaf of layers) {
          if (!leaf.hasOwnProperty("children") || leaf.children.length === 0) {
            activeLayers.push(leaf);
          }
        }

        sessionStorage.setItem("active_layers", JSON.stringify(activeLayers));
        bus.$emit("update-geoserver-layers");
      }
    },

    updateExpandedLayers(layersLevels) {
      if (this.loadedExpandedLayers) {
        this.openLayers = layersLevels;
        sessionStorage.setItem(
          "expanded_layer_levels",
          JSON.stringify(layersLevels)
        );
      }
    },

    updateActiveGeoserverLabels() {
      sessionStorage.setItem(
        "active_geoserver_labels",
        JSON.stringify(this.activeGeoserverLabels)
      );
      bus.$emit("update-geoserver-layers");
    },

    getLayerLevelLayerName(layerLevel) {
      return layerLevel.layers[0].layer.layer;
    },

    isGeoserverLabelActive(layerLevel, selected) {
      if (layerLevel.layers.length > 0) {
        let layer = this.getLayerLevelLayerName(layerLevel);
        if (selected) {
          return this.activeGeoserverLabels.includes(layer);
        } else {
          let activeGeoserverLabelIndex = this.activeGeoserverLabels.findIndex(
            item => item === layer
          );
          if (activeGeoserverLabelIndex !== -1) {
            this.activeGeoserverLabels.splice(activeGeoserverLabelIndex, 1);
          }
          return false;
        }
      }
    },

    toggleGeoserverLabel(layerLevel) {
      let layer = this.getLayerLevelLayerName(layerLevel);
      let activeGeoserverLabelIndex = this.activeGeoserverLabels.findIndex(
        item => item === layer
      );
      if (activeGeoserverLabelIndex !== -1) {
        this.activeGeoserverLabels.splice(activeGeoserverLabelIndex, 1);
      } else {
        this.activeGeoserverLabels.push(layer);
      }
      this.updateActiveGeoserverLabels();
    },

    toggleShowTabNetworkLayers() {
      this.setShowTabNetworkLayers(!this.showNetworkLayers);
    },

    closeLayers() {
      this.$emit("close");
    },

    /**
     * Update the selected map layer. When selecting a layer referring to the map,
     * it is necessary to issue an event to the map with the respective layer.
     * @param layer
     */
    updateSelectedLayersMap(layer) {
      if (this.selectedMapLayer.id === layer.id) {
        this.selectedMapLayer = {};
      } else {
        this.selectedMapLayer = layer;
      }
      sessionStorage.setItem(
        "active_layer_map",
        JSON.stringify(this.selectedMapLayer)
      );
      this.mapLayerSelection(this.selectedMapLayer);
    },
    /**
     * @param selectedMapLayer - selectedMapLayer
     * issues event to map with respective layer
     */
    mapLayerSelection(selectedMapLayer) {
      switch (selectedMapLayer.translatable_label) {
        case "Dark":
          /** Emits an event to set the map to dark mode **/
          this.$store.dispatch("SET_MAP_STYLE", "dark-map");
          bus.$emit("change-view-type", "roadMapLayer");
          break;
        case "Light":
          /** Emits an event to set the map to light mode **/
          this.$store.dispatch("SET_MAP_STYLE", "light-map");
          bus.$emit("change-view-type", "roadMapLayer");
          break;
        case "DefaultSatellite":
          bus.$emit("change-view-type", "aerialMapLayer");
          break;
        case "OpenStreetMap":
          bus.$emit("change-view-type", "openStreetMap");
          break;
        default:
          bus.$emit("change-view-type", "newLayer");
          break;
      }
    },

    /**
     * Define which map layers are selected.
     * If there is a layer in sessionStorage, that same layer is selected.
     * If not, select the layer in which the value of the variable 'selected_default' is true
     */
    setSelectedMapLayers() {
      let selectedLayer = JSON.parse(
        sessionStorage.getItem("active_layer_map")
      );

      if (selectedLayer) {
        this.selectedMapLayer = selectedLayer;
        this.mapLayerSelection(this.selectedMapLayer);
      } else {
        for (const layer of this.layersMap) {
          for (const layerMap of layer.children) {
            if (
              layerMap.hasOwnProperty("selected_default") &&
              layerMap.selected_default
            ) {
              this.updateSelectedLayersMap(layerMap);
            }
          }
        }
      }
    },

    /**
     * Set whether the map layer is expanded.
     * If in sessionStorage there is a layer, the map layer is expanded
     */
    setOpenMapLayers() {
      let expandedSidebarLayers = JSON.parse(
        sessionStorage.getItem("expanded_map_layer_levels")
      );
      if (expandedSidebarLayers) {
        this.openMapLayer = expandedSidebarLayers;
      }
      this.loadedExpandedMapLayer = true;
    },

    /**
     * Update expanded map layer
     * @param layer
     */
    updateExpandedMapLayer(layer) {
      if (this.loadedExpandedMapLayer) {
        this.openMapLayer = layer;
        sessionStorage.setItem(
          "expanded_map_layer_levels",
          JSON.stringify(layer)
        );
      }
    }
  }
};
</script>

<style scoped>
.layers-title {
  margin-bottom: 14px;
}
.layers-tree {
  overflow-x: hidden !important;
  width: 100%;
  height: calc(100% - 110px);
  overflow: auto;
  padding: 6px !important;
}

.layer-item-label {
  color: #1e2329;
  font-size: 10px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.layer-search {
  flex: 0 0 auto;
  width: 100%;
  font-size: 12px;
}
</style>

<style>
#layers-sidebar-tree .v-treeview-node .v-treeview-node__checkbox,
#layers-sidebar-tree .v-treeview-node__content {
  margin-left: 0;
}

#layers-sidebar-tree .v-treeview-node__level {
  width: 18px;
}

#layers-sidebar-tree .v-treeview-node__root {
  min-height: 22px;
  padding: 0;
  margin-bottom: 2px;
}

#layers-sidebar-tree .v-icon.v-icon {
  color: #767676 !important;
  font-size: 18px;
  margin-left: 0 !important;
  height: 100% !important;
  width: 18px !important;
}

#layers-sidebar-tree .v-treeview-node__prepend {
  min-width: unset !important;
  margin: 0 !important;
}
#layers-sidebar-tree .v-input--selection-controls__input,
#layers-sidebar-tree .v-input--selection-controls,
#layers-sidebar-tree .v-input__slot {
  margin: 0 !important;
  padding: 0 !important;
}

#layers-sidebar-tree .v-input--selection-controls__input {
  height: unset !important;
}

.layers-filter {
  padding-left: 10px;
  font-size: 12px;
  font-weight: 500;
}

.layer-title.theme--light.v-input--is-disabled {
  background-color: #fff !important;
  color: #767676 !important;
}

.layer-title.theme--light.v-text-field.v-input--is-disabled .v-input__slot:before {
  border-image: none !important;
}

.layer-title.theme--light.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #fff !important;
}

.layers-title.v-text-field > .v-input__control > .v-input__slot:before {
  border-color: #fff !important;
  border-style: none !important;
  border-width: none !important;
}

.textFieldLayers {
  width: 70px;
  height: 20px;
  font-size: 10px;
  border-style: none !important;
}

.layertitleTextContainer {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.layerProfile {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: rgba(118, 118, 118, 0.5)
}

.layerTitle {
  font-family: 'Lato';
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 20px;
  color: #767676;
  text-transform: uppercase;
}

.labelSpan {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.0616822px;
  color: #767676;
  margin-left: 12px;
}

.defaultChevron {
  color: "rgba(118, 118, 118, 0.5)"
}

/**
 * remove bottom border
 
.layer-search.v-text-field > .v-input__control > .v-input__slot:before,
.layer-search.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none !important;
}
*/
</style>

<style scoped>
.theme--light.v-input--is-disabled >>> input,
.theme--light.v-input--is-disabled >>> textarea {
  background-color: #fff !important;
  color: #767676 !important;
}
.v-treeview >>> .v-treeview-node__append {
  min-width: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/SideBar/SidebarWindows/Layers/Layers.vue